<div *ngIf="projectContractStages$ | async as contractStages">
  <div [hidden]="contractStages.length == 0">
    <h3>Contracts</h3>
    <div *ngFor="let stage of contractStages">
      <eic-contract-stage [stage]="stage"
                          (contract_selected)="contractSelected($event)"  
                          (project_selected)="projectSelected($event)"  
                          [currentProject]="currentProject">
      </eic-contract-stage>
    </div>
  </div>
</div>
<!-- -->
